import { styled, Theme } from "@mui/material/styles";

export const Image = styled("img")({
  objectFit: "cover",
  height: "100%",
  width: "100%",
});


export const emptyStyle = (theme: Theme) => ({
  position: "relative",
  borderRadius: "50%",
  backgroundColor: "#F4EFEB",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "32px",
  fontFamily: "Grenette Pro",
  border: "2.5px solid white",
  marginRight: "-1rem",
  zIndex: 2,
});
